import { createSignal, type Component } from 'solid-js';
import { t } from '@trimble/i18n';
import tinycolor from 'tinycolor2';

export interface ColorInputFieldProps {
  inputType: 'hex' | 'rgb';
  labelTranslationKey: string;
  initialValue: string;
  testId?: string;
  onChange?(val: string): void;
}

export const ColorInputField: Component<ColorInputFieldProps> = (props) => {
  const rgbMinVal: number = 0;
  const rgbMaxval: number = 255;

  const [isValidInput, setIsValidInput] = createSignal<boolean>(true);

  function validateInputValue(value: string): boolean {
    if (props.inputType === 'hex') {
      return tinycolor(value).isValid();
    } else {
      const num = Number.parseInt(value, 10);
      return !isNaN(num) && num >= rgbMinVal && num <= rgbMaxval;
    }
  }

  function onInputChange(e: Event & { target: HTMLInputElement }): void {
    const valid = validateInputValue(e.target.value);
    setIsValidInput(valid);
    if (valid) {
      props.onChange?.(e.target.value);
    }
  }

  return (
    <>
      <div
        class={`grow flex flex-col align-middle text-center p-1 ${props.inputType === 'hex' ? 'w-[40%]' : 'w-[20%]'}`}
      >
        <input
          data-testid={props.testId}
          class={`w-full border-2 ${
            isValidInput() ? 'border-gray-1' : 'border-red'
          } overflow-visible text-center text-sm pt-0.5 pb-0.5`}
          value={props.initialValue}
          onChange={onInputChange}
        />
        {t(props.labelTranslationKey)}
      </div>
    </>
  );
};
